import { useEffect, useState } from 'react';
import { getContentBySection } from '../../api/content';
import './Solutions.css';

const DEFAULTS = {
  label: 'O que entregamos',
  heading: 'Soluções',
  cta_link: 'https://wa.me/5531985558887',
  cta_texto: 'Falar com especialista →',
  sol1_num: '01', sol1_titulo: 'ERP Gerenciar', sol1_desc: 'Sistema integrado de gestão empresarial, do financeiro ao RH, em uma única plataforma robusta e intuitiva.', sol1_tag: 'Core Product',
  sol2_num: '02', sol2_titulo: 'BI & Analytics', sol2_desc: 'Dashboards em tempo real e relatórios gerenciais para tomada de decisão baseada em dados concretos.', sol2_tag: 'Dados',
  sol3_num: '03', sol3_titulo: 'Saúde Digital', sol3_desc: 'Sistemas especializados para operadoras, clínicas e administradoras de benefícios. Conformidade e eficiência.', sol3_tag: 'Vertical',
  sol4_num: '04', sol4_titulo: 'Integrações & API', sol4_desc: 'Conectamos seu ecossistema — ERPs legados, plataformas externas e serviços financeiros com segurança total.', sol4_tag: 'Conectividade',
  sol5_num: '05', sol5_titulo: 'Segurança & LGPD', sol5_desc: 'Compliance desde a arquitetura. Proteção de dados, auditoria e conformidade com a legislação brasileira.', sol5_tag: 'Compliance',
  sol6_num: '06', sol6_titulo: 'Cloud & Infra', sol6_desc: 'Alta disponibilidade em parceria com Onex Data Center. Escalabilidade e SLA garantidos para operações críticas.', sol6_tag: 'Infraestrutura',
};

const Solutions = () => {
  const [content, setContent] = useState(DEFAULTS);

  useEffect(() => {
    getContentBySection('solutions').then(data => {
      if (Object.keys(data).length > 0) {
        setContent(prev => ({ ...prev, ...data }));
      }
    }).catch(() => {});
  }, []);

  const solutions = [
    { num: content.sol1_num, title: content.sol1_titulo, desc: content.sol1_desc, tag: content.sol1_tag },
    { num: content.sol2_num, title: content.sol2_titulo, desc: content.sol2_desc, tag: content.sol2_tag },
    { num: content.sol3_num, title: content.sol3_titulo, desc: content.sol3_desc, tag: content.sol3_tag },
    { num: content.sol4_num, title: content.sol4_titulo, desc: content.sol4_desc, tag: content.sol4_tag },
    { num: content.sol5_num, title: content.sol5_titulo, desc: content.sol5_desc, tag: content.sol5_tag },
    { num: content.sol6_num, title: content.sol6_titulo, desc: content.sol6_desc, tag: content.sol6_tag },
  ];

  return (
    <section className="solutions" id="solucoes">
      <div className="solutions__header">
        <div>
          <p className="g-label">{content.label}</p>
          <h2 className="g-heading">{content.heading}</h2>
        </div>
        <a href={content.cta_link} target="_blank" rel="noopener noreferrer" className="solutions__cta-link">
          {content.cta_texto}
        </a>
      </div>

      <div className="solutions__grid">
        {solutions.map(({ num, title, desc, tag }) => (
          <div className="solutions__card" key={num}>
            <span className="solutions__card-num">{num}</span>
            <div className="solutions__card-bar" aria-hidden="true" />
            <h3 className="solutions__card-title">{title}</h3>
            <p className="solutions__card-desc">{desc}</p>
            <span className="solutions__card-tag">{tag}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Solutions;